import { render, staticRenderFns } from "./Insquary.vue?vue&type=template&id=cc440540&scoped=true&"
import script from "./Insquary.vue?vue&type=script&lang=js&"
export * from "./Insquary.vue?vue&type=script&lang=js&"
import style0 from "./Insquary.vue?vue&type=style&index=0&id=cc440540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc440540",
  null
  
)

export default component.exports